/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';
import { LexplusUpdateAufgabeInhaltDto } from '../../models/lexplus-update-aufgabe-inhalt-dto';

export interface AufgabenControllerUpdateInhaltV1$Params {
  id: number;
      body: LexplusUpdateAufgabeInhaltDto
}

export function aufgabenControllerUpdateInhaltV1(http: HttpClient, rootUrl: string, params: AufgabenControllerUpdateInhaltV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerUpdateInhaltV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

aufgabenControllerUpdateInhaltV1.PATH = '/v1/aufgaben/{id}/inhalt';
